module.exports = __webpack_public_path__ + "components/flag/static/square/uy-ccd00b251601fd7c66ffe013435ce8cd.svg";